









































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ShippingCompany from '@/api/shipping/index'
import PicModal from '@/components/upload/picModal.vue'
import AreaModal from '@/components/areaModal/index.vue'

@Component({
  components: {
    PicModal,
    AreaModal
  }
})
export default class EditShippingTemplate extends AbpBase {
  form = {
    name: null,
    isFree: false,
    value: null,
    calcType: 0, // 0 按件计算 1 按金额计算
    calcRules: [],
    areas: [],
    published: false
  }

  validateCalcRules = (rule, value, callback) => {
    if (value.length == 0) {
      return callback(new Error('请添加计算规则'))
    } else {
      let isvalid = value.some(item => {
        if (item.min == null || item.max == null || !item.shippingFee) {
          callback(new Error('请输入计算规则'))
          return true
        }

        if (item.min > item.max) {
          callback(new Error('计算规则区间最小值不能大于最大值'))
          return true
        }
      })

      if (!isvalid) {
        callback()
      }
    }
  }

  validateValue(rule, value, callback) {
    let vm = this
    if (!this.form.isFree) {
      callback()
    } else if (!value) {
      callback(new Error('请输入满多少包邮'))
    } else {
      callback()
    }
  }

  ruleForm = {
    name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
    calcRules: [{ validator: this.validateCalcRules, trigger: 'blur' }],
    value: [{ validator: this.validateValue, trigger: 'blur' }]
  }

  created() {
    this.getShippingTemplate()
  }

  /**
   * 获取运费模板
   */
  getShippingTemplate() {
    let companyId = this.$route.query['companyId']
    let templateId = this.$route.query['templateId']
    if (companyId && templateId) {
      ShippingCompany.getShippingTemplate(
        companyId.toString(),
        templateId.toString()
      ).then(res => {
        if(res.data.value) {
          res.data.value = Number(res.data.value)
          res.data.calcRules.forEach(item => {
            if(item.min != null) {
              item.min = Number(item.min)
            }
            if(item.max != null) {
              item.max = Number(item.max)
            }
          })
        }
        this.form = res.data
      })
    }
  }

  /**
   * 添加计算规则
   */
  addRuleFn() {
    let obj = {
      min: null,
      max: null,
      shippingFee: null
    }

    this.form.calcRules.push(obj)
  }

  deleteRuleFn(index) {
    this.form.calcRules.splice(index, 1)
  }

  /**
   * 选择地区
   */
  areaChange(e) {
    this.form.areas = e
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate(valid => {
      if (valid) {
        let companyId = vm.$route.query['companyId']
        ShippingCompany.updateShippingTemplate(
          companyId.toString(),
          vm.form
        ).then(res => {
          vm.$router.push({
            name: 'shippingList',
            query: {
              id: vm.$route.query['companyId']
            }
          })
        })
      }
    })
  }
}
